<template>
  <section>
    <div class="align">
      <h1>Контакты</h1>
      <p>ООО МКК «ФИНМОЛЛ» Общество с ограниченной ответственностью Микрокредитная компания «ФИНМОЛЛ»</p>


      <div id="contactDesc">
        <phone></phone>
        <mail></mail>
        <adress></adress>
      </div>


      <p id="descInfoText">Сумма займа от {{deal.minBaseProduct.Amount}} до {{deal.maxIndividualProduct.Amount}} рублей.<br>
      Срок займа {{deal.maxBaseProduct.Period}} недели.<br>
      Процентная ставка от {{deal.maxIndividualProduct.PercentageRate}} до {{deal.maxBaseProduct.PercentageRate}} % годовых.<br>
      Обязательные платные услуги отсутствуют.<br>
      Ответственность за неисполнение или ненадлежащее исполнение обязательства (неустойка, пеня) отсутствует.<br>
      Требования к заемщикам: возраст от 18 до 70 лет. Гражданство РФ. Постоянная регистрация на территории РФ.
      Наличие контактного телефонного номера.<br>
      ООО МКК «ФИНМОЛЛ». Регистрационный номер в государственном реестре МФО: 651403550005541. ОГРН 1117746509638.
      Юридический адрес: 630112, Новосибирская область, город Новосибирск, улица Фрунзе, дом 242, помещение 406.</p>
      <form id="footerForm" class="rapeAlign" style="display: none;">
        <h2>Получите деньги сегодня</h2>
        <div id="footerFormInputLine">
<!--          <fmInput-->
<!--            :name="'PHONE'"-->
<!--            :label="'Ваш телефон'"-->
<!--            :placeholder="'Введите телефон'"-->
<!--            :vmask="'+7 (###) ###-##-##'"-->
<!--            :type="'tel'"-->
<!--          ></fmInput>-->
<!--          <fmInput-->
<!--            :name="'EMAIL'"-->
<!--            :label="'Ваш E-mail'"-->
<!--            :placeholder="'Введите E-mail'"-->
<!--            :type="'text'"-->
<!--            :vmask="''"-->
<!--          ></fmInput>-->
          <button class="svgMoney">
            <IconBase :viewBox="'0 0 24 24'">
              <IconPayments></IconPayments>
            </IconBase>
            <span>Получить деньги</span>
            <IconBase :viewBox="'0 0 24 24'">
              <IconPayments></IconPayments>
            </IconBase>
          </button>
        </div>
        <afterButton></afterButton>

      </form>
    </div>
  </section>
</template>

<script>
  import {mapState} from 'vuex';
  export default {
    name: "contact",
    components: {
      phone: () => import('@/components/chunk/phone'),
      mail: () => import('@/components/chunk/email'),
      adress: () => import('@/components/chunk/adress'),
      // fmInput: () => import('@/components/form/fmInput'),
      IconBase: () => import('@/components/svg/IconBase'),
      IconPayments: () => import('@/components/svg/payments-finance-36'),
      afterButton: () => import('@/components/chunk/nxtStepAfterButton'),
    },
    computed:{
      ...mapState({
        deal: state => state.Deal
      })
    }
  }
</script>

<style scoped>
  section {background: #F9F9F8;padding-bottom: 0;}
  #contactDesc {}
  #contactDesc > div {margin: 4.7vw 0;}
  section > .align > h1 {}

  section > .align > p {font-size: 5vw;padding: 16px 0 20px;}
  #footerForm {background: #0D5A44;color: white;padding: 10vw 5vw;}
  #footerForm h2 {padding-bottom: 2vw;}
  .info {padding: 0 3vw;}
  #footerForm button {margin-top: 3vw}
  #descInfoText{font-size: 4.4vw;}

  @media screen and (min-width: 760px) {

    #contactDesc {}
    section > .align > h1 {}
    section > .align > p {font-size: 1.4vw}

    #footerForm {padding: 2.7vw 5.7vw;
      width: 78.6vw;}
    #footerForm > div {display: flex;align-items: center;justify-content: space-between;}
    #footerForm > div > div:nth-child(1) {width: 25.5vw;}
    #footerForm > div > div:nth-child(2) {width: 25.5vw}
    #footerForm > div > button {width: 22vw}
    #footerForm > div > div, #footerForm > div > button {margin: 0}
    #contactDesc {display: flex;align-items: flex-start;justify-content: space-between;width: 90vw;margin: 2.7vw 0}
    #contactDesc > div:nth-child(1) {width: 20.2vw}
    #contactDesc > div:nth-child(2) {width: 20.2vw}
    #contactDesc > div:nth-child(3) {width: 47vw}
    #footerForm > div:last-child {justify-content: flex-end}

    #contactDesc > div {margin: 0;}
    #footerFormInputLine {}
    #descInfoText{font-size: 1.3vw;}
  }
  @media screen and (min-width: 1140px) {
    section > .align > p {font-size: 16px}

    #footerForm {padding: 30px 64px;width: 896px;}

    #footerForm > div > div:nth-child(1) {width: 290px;}
    #footerForm > div > div:nth-child(2) {width: 290px;}
    #footerForm > div > button {width: 250px;}
    #footerForm > div > div, #footerForm > div > button {margin: 0}
    #contactDesc {width: 1024px;margin: 30px 0}
    #contactDesc > div:nth-child(1) {width: 240px}
    #contactDesc > div:nth-child(2) {width: 240px}
    #contactDesc > div:nth-child(3) {width: 540px;}

    #footerFormInputLine {margin-bottom: 15px;}
    #descInfoText{font-size: 14px;}
  }
</style>
